/**
 * @file       Files vuex store, used by the whole files module.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import axios from "@/plugins/axios.js";
var qs = require("qs");

/**
 * Gets the default state.
 *
 * @return  {Object}  The default state.
 */
function getDefaultState() {
  return {
    download: {
      status: null,
      data: null,
      error: null
    }
  };
}

/**
 * Files vuex actions.
 *
 * @type  {Object}
 */
const actions = {
  /**
   * Get the file to download.
   *
   * @param   {Function}  arg1.commit  Commit the action
   * @param   {Object}    params       The parameters
   *
   * @return  {Promise}
   */
  getFileDownload: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      commit("onGetFileDownload");
      axios({
        url: `${params.userType}/export`,
        method: "GET",
        params: params,
        responseType: "blob",
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      })
        .then(response => {
          commit("onGetFileDownloadSuccess", {
            response,
            params
          });
          resolve(response);
        })
        .catch(error => {
          commit("onGetFileDownloadError", error);
          reject(error);
        });
    });
  },

  /**
   * Get user export XLS file.
   *
   * @param   {Function}  arg1.commit  Commit the action
   * @param   {Object}    params       The parameters
   *
   * @return  {Promise}
   */
  getUserExportXls: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      commit("onGetFileDownload");
      axios({
        url: "user/export",
        method: "GET",
        params: params,
        responseType: "blob",
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      })
        .then(response => {
          commit("onGetFileDownloadSuccess", {
            response,
            params
          });
          resolve(response);
        })
        .catch(error => {
          commit("onGetFileDownloadError", error);
          reject(error);
        });
    });
  }
};

/**
 * Files vuex mutations.
 *
 * @type  {Object}
 */
const mutations = {
  /**
   * Get file download.
   *
   * @param  {Object}  state   The vuex state
   */
  onGetFileDownload: state => {
    state.download.status = "fetching";
    state.download.errors = {};
  },

  /**
   * Commit login success.
   *
   * @param  {Object}  state            The vuex state
   * @param  {Object}  arg2.response    The response
   * @param  {Object}  arg2.params      The parameters
   */
  onGetFileDownloadSuccess: (state, { response, params }) => {
    state.download.status = "success";
    state.download.errors = {};
    const blob = new Blob([response.data], { type: response.data.type });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = params.name + ".xls" || "fichier.xls";
    link.click();
  },

  /**
   * Get file download error.
   *
   * @param  {Object}  state   The vuex state
   * @param  {Object}  err     The error
   */
  onGetFileDownloadError: (state, err) => {
    state.download.status = "error";
    state.download.errors = err;
  }
};

/**
 * Export the store.
 *
 * @type  {Object}
 */
export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  mutations
};
